import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import classNames from 'classnames';
import { ITabs, TabSize } from './Tabs.types';
import { useScreenSize } from '../../utils/hooks/useScreenSize';
import { TabsModal } from './TabsModal/TabsModal';
import styles from './Tabs.module.scss';

const TabSizeClassName = {
  [TabSize.Small]: 'tab-small',
  [TabSize.Medium]: 'tab-medium',
  [TabSize.Large]: 'tab-large',
};

export const Tabs: React.FC<ITabs> = (props) => {
  const {
    tabs,
    onTabChange,
    size = TabSize.Medium,
    allowToChangeTab = true,
    className,
    activeTabIndex,
    tabClassName,
  } = props;
  const [activeIndex, setActiveIndex] = useState<number>(activeTabIndex || 0);
  const isMobile = useScreenSize().isMobile;

  useEffect(() => {
    if (activeTabIndex !== undefined && activeTabIndex !== activeIndex) {
      setActiveIndex(activeTabIndex);
    }
  }, [activeTabIndex]);

  // Handle tab change
  const handleTabChange = (index: number) => {
    if (allowToChangeTab) {
      setActiveIndex(index);
    }
    onTabChange?.(index);
  };

  if (isMobile) {
    return <TabsModal {...props} />;
  }

  return (
    <TabView
      className={classNames(styles['ds-tabs-container'], className, styles[TabSizeClassName[size]])}
      panelContainerClassName={tabClassName}
      activeIndex={activeIndex}
      onTabChange={(e) => handleTabChange(e.index)}
    >
      {tabs.map((tab, index) =>
        tab.visible === false ? null : (
          <TabPanel key={index} header={tab.header} disabled={tab.disabled}>
            {tab.content}
          </TabPanel>
        )
      )}
    </TabView>
  );
};
